import { useTranslation } from 'next-i18next'
import { AiFillThunderbolt } from 'react-icons/ai'
import cn from 'classnames'
import { FC, useContext, useReducer, useState } from 'react'
import { IUser } from '@contexts/user/user.utils'
import { UserContext } from '@contexts/user/user.context'
import cartServices from '@services/cartservices'
import { useCart } from '@contexts/cart/cart.context'
import { generateCartItem } from '@utils/generate-cart-item'
import { ROUTES } from '@utils/routes'
import Router from 'next/router'
import OutlineButton from '@components/ui/outline-button'
import { BUYNOW_TEMPORARY_TOKEN } from '@constants/index'
import { setBuyNowToken } from '@utils/localStorage'
import { useModalAction } from '@components/common/modal/modal.context'
import { toast } from 'react-toastify'

const ProductBuyNow: FC<any> = ({ data, quantity, className }: any) => {
  const { t } = useTranslation()
  const { closeModal } = useModalAction()
  const {
    cartId,
    isGuest,
    user,
    addToCartLoader,
    setAddToCartLoader,
    addToBuyNowLoader,
    setAddToBuyNowLoader,
    cartLoader,
  } = useContext(UserContext) as IUser

  const { addBuyNowItemToCart } = useCart()

  const addToCart = async (newToken: any) => {
    const addToCartItem = generateCartItem(data)
    addBuyNowItemToCart(addToCartItem, quantity, newToken)
    closeModal()
  }
  const buyNow = async (sku: any, cartId: any) => {
    if (addToBuyNowLoader) return // Prevent duplicate clicks while loading
    setAddToCartLoader(true)
    setAddToBuyNowLoader(true)
    let buyNowResponse
    const payload = {
      cartItem: {
        qty: quantity,
        sku: sku,
        vendor_id: process?.env?.NEXT_PUBLIC_VENDOR_ID,
      },
      ...(user && user?.id && { customer_id: user?.id }),
      ...(isGuest && cartId && { quote_id: cartId }),
    }
    if (isGuest) {
      await cartServices.guestCartIdBuyNow(cartId)
      buyNowResponse = await cartServices.guestBuyNow(payload)
    } else {
      buyNowResponse = await cartServices.customerBuyNow(payload)
    }
    // const buyNowResponse = await cartServices.guestBuyNow(productId, payload)
    if (buyNowResponse.quote_id) {
      setBuyNowToken(BUYNOW_TEMPORARY_TOKEN, buyNowResponse.quote_id)
      // const currentSession = await cartServices.currentSession()
      addToCart(buyNowResponse.quote_id)
      setAddToBuyNowLoader(false)
    } else {
      toast.error(buyNowResponse?.message, {
        position: toast.POSITION.TOP_RIGHT,
        className: 'toast-error',
      })
      setAddToBuyNowLoader(false)
      setAddToCartLoader(false)
    }
  }

  const rootClassName = cn(
    'w-[140px] md:w-[180px]  h-11 md:h-14  px-3 whitespace-nowrap !border-brand',
    className,
  )
  const disabledBuyNow =
    addToBuyNowLoader || !cartId?.id || addToCartLoader || cartLoader
  return (
    data?.is_in_stock && (
      <OutlineButton
        className={cn(
          `${
            (!cartId?.id && 'cursor-wait opacity-30') ||
            ((addToCartLoader || cartLoader) &&
              ' cursor-not-allowed hover:cursor-not-allowed opacity-30')
          } `,
          rootClassName,
        )}
        onClick={() => buyNow(data?.sku, cartId?.id)}
        disabled={disabledBuyNow}
        loading={addToBuyNowLoader}
      >
        <AiFillThunderbolt className="inline-flex mr-2" />
        {t('text-buy-now')}
      </OutlineButton>
    )
  )
}

export default ProductBuyNow
